// RoutesConfig.js
import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { useSelector } from 'react-redux'
import SignInForm from './components/login/SignInForm.jsx'
import IntakeInfo from './components/IntakeTraige/IntakeInfo'
import ApplicationSummary from './components/IntakeTraige/ApplicationSummary'
import DocumentSummary from './components/IntakeTraige/DocumentSummary'
import ConversationDrawer from './components/Coversation'
import AppChatBot from './components/AppChatBot.jsx'
import AppetiteSummary from './components/AppetiteSummary/AppetiteSummary'
import EscalationOverview from './components/EscalationOverview/EscalationOverview'
import CompanyForm from './components/Integrations/CompanyForm'
import MoveCameraWithGeoJSON from './components/ThreeDMap.jsx'
import PdfJsonViewerV2 from './components/PDFViewer/PDFViewerNew'
import Container from './components/AppetiteManagement/Container'
import Analytics from './components/Analytics'
function RoutesConfig () {
  const selectedApplicationId = useSelector(
    state => state.intakeData.selectedAppId
  )

  return (
    <Routes key={window.location.pathname}>
      <Route path='*' element={<SignInForm />} />
      <Route
        path='/app/details'
        element={
          <>
            <ConversationDrawer selectedApplicationId={selectedApplicationId} />
            <IntakeInfo />
            <ApplicationSummary />
            <DocumentSummary />
            <AppChatBot className='fixed top-4 right-4' />
          </>
        }
      />
      <Route
        path='/app/intake/:id'
        element={
          <>
            <ConversationDrawer selectedApplicationId={selectedApplicationId} />
            <AppetiteSummary />
            <AppChatBot className='fixed top-4 right-4' />
          </>
        }
      />
      <Route
        path='/app/escalate'
        element={
          <>
            <ConversationDrawer selectedApplicationId={selectedApplicationId} />
            <EscalationOverview />
            <AppChatBot className='fixed top-4 right-4' />
          </>
        }
      />
      <Route
        path='/app/integrations'
        element={
          <>
            <ConversationDrawer selectedApplicationId={selectedApplicationId} />
            <CompanyForm />
            <AppChatBot className='fixed top-4 right-4' />
          </>
        }
      />
      <Route
        path='/app/locations'
        element={
          <>
            <ConversationDrawer selectedApplicationId={selectedApplicationId} />
            <MoveCameraWithGeoJSON />
            <AppChatBot className='fixed top-4 right-4' />
          </>
        }
      />
      <Route
        path='/app/analytics'
        element={
          <>
            <ConversationDrawer selectedApplicationId={selectedApplicationId} />
            <Analytics />
            <AppChatBot className='fixed top-4 right-4' />
          </>
        }
      />
      <Route path='/app/pdfviewer' element={<PdfJsonViewerV2 />} />
      <Route
        path='/app/appetite'
        element={
          <>
            <Container />
          </>
        }
      />
      <Route path='/app/pdfviewer' element={<PdfJsonViewerV2 />} />
    </Routes>
  )
}

export default RoutesConfig
